import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { getUserScopedStorageKeyPrefix } from './get-user-scoped-storage-key-prefix';
export var UserScopedLocalStorage = /*#__PURE__*/function () {
  function UserScopedLocalStorage(userId) {
    _classCallCheck(this, UserScopedLocalStorage);

    _defineProperty(this, "storageKeyPrefix", void 0);

    this.storageKeyPrefix = getUserScopedStorageKeyPrefix(userId);
  }

  _createClass(UserScopedLocalStorage, [{
    key: "getItem",
    value: function getItem(key) {
      // To handle backwards compatibility, we need to retrofit non-user-scoped local storage values to be user-scoped if they exist.
      var nonUserScopedLocalStorageValue = window.localStorage.getItem(key);

      if (nonUserScopedLocalStorageValue !== null) {
        this.setItem(key, nonUserScopedLocalStorageValue);
      }

      return window.localStorage.getItem(this.storageKeyPrefix + key);
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      window.localStorage.setItem(this.storageKeyPrefix + key, value);
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      // Following the backwards compatiblity functionality in `getItem()`:
      // We need to simultaneously remove non-user-scoped versions of user-scoped local storage entries too if they exist.
      window.localStorage.removeItem(key);
      window.localStorage.removeItem(this.storageKeyPrefix + key);
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this = this;

      Object.keys(window.localStorage).filter(function (key) {
        return key.startsWith(_this.storageKeyPrefix);
      }).forEach(function (key) {
        return window.localStorage.removeItem(key);
      });
    }
  }]);

  return UserScopedLocalStorage;
}();